import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respDataPartner: null,
    profilePartnerId: '',
    calendarOptions: [
      // {
      //   color: 'danger',
      //   label: 'Personal',
      // },
      // {
      //   color: 'primary',
      //   label: 'Business',
      // },
      // {
      //   color: 'warning',
      //   label: 'Family',
      // },
      // {
      //   color: 'success',
      //   label: 'Holiday',
      // },
      // {
      //   color: 'info',
      //   label: 'ETC',
      // },
    ],
    selectedCalendars: [],
  },
  getters: {},
  mutations: {
    GET_PARTNER(state, payload) {
      state.respDataPartner = payload
    },
    SET_SELECT_PROFILEPARTNERID(state, payload) {
      state.profilePartnerId = payload
    },
    SET_CALENDAR_TYPE(state, payload) {
      state.calendarOptions = payload
      state.selectedCalendars = payload.map(p => p._id)
    },
    SET_SELECT_CALENDAR(state, payload) {
      state.selectedCalendars = payload
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getCalendarsType(ctx, item) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/web/application/hero/queueMonitor/getCalendarsType')
          .then(response => {
            resolve(response.data.data)
            ctx.commit('SET_CALENDAR_TYPE', response.data.data)
          })
          .catch(error => reject(error))
      })
    },
    fetchEvents(ctx, { calendars, profilePartnerId }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/web/application/hero/queueMonitor/get', {
            params: {
              calendars: calendars.join(','),
              profilePartnerId,
            },
          })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    addEvent(ctx, event) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/web/application/hero/queueMonitor/add', { event })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, event) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/hero/queueMonitor/update', { event })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, { id, _id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/web/application/hero/queueMonitor/delete?id=${id}&_id=${_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getPartner({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/hero/queueMonitor/getPartner?calendars=${item.calendars}&pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET_PARTNER', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
